const translations = {
    createOperatorTileToastMessage:
        'Your Service Provider Tile has been submitted for review. Once approved, it will be publicly visible.',
    updateOperatorTileToastMessage:
        'Your Service Provider Tile update has been submitted for review. Once approved, it will be publicly visible.'
};

export default translations;
